import { Component, ComponentFactoryResolver, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LOCALE_CONFIG, Logger } from '@common-lib';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmPopupComponent } from '../../components/';
import { ConfigurationService, PoliciesService, SubcategoriesService, TranslationsService } from '../../pages-services';
import {saveAs} from 'file-saver/FileSaver';
import * as moment from 'moment';


@Component({
    selector: 'app-settings-policies',
    templateUrl: './settings-policies.component.html',
    styleUrls: ['./settings-policies.component.scss']
})
export class SettingsPoliciesComponent implements OnInit {

    editModalRef: BsModalRef;
    editModalConditionRef: BsModalRef;
    selectedRow: {
        id: number | string,
        name: string,
        action: string,
        segment: string[],
        locale: string[],
        variant: string,
        connector: string,
        subGroups: string[],
        conditions: any[],
        target: string,
        subcategory: string,
        new: boolean
    };
    selectedRowCondition: {
        subcategoryId: string,
        subcategoryRelation: string,
        variantId: string,
        variantRelation: string,
    };
    searchTerm = '';
    isUploading = false;
    isExporting = false;

    @ViewChild('editFormTemplate')
    editFormTemplate: TemplateRef<any>;
    @ViewChild('editConditionTemplate')
    editConditionTemplate: TemplateRef<any>;

    tableConfiguration = {
        searchEnabled: false,
        headerEnabled: true,
        orderEnabled: true,
        globalSearchEnabled: false,
        paginationEnabled: true,
        exportEnabled: false,
        clickEvent: false,
        selectRow: false,
        selectCol: false,
        selectCell: false,
        rows: 50,
        additionalActions: false,
        serverPagination: false,
        isLoading: false,
        detailsTemplate: false,
        groupRows: false,
        paginationRangeEnabled: true,
        collapseAllRows: false,
        checkboxes: false
    };

    columns = [
        { key: 'name', title: 'Name' },
        { key: 'action', title: 'Action' },
        { key: 'subcategory', title: 'Subcategory' },
        { key: 'segment', title: 'Segments' },
        { key: 'locale', title: 'Locales' },
        { key: 'variant', title: 'Variant' },
        { key: 'actions', title: 'Actions' }
    ];
    conditionsColumns = [
        { key: 'subcategoryId', title: 'Subcategory' },
        { key: 'subcategoryRelation', title: 'Relation' },
        { key: 'variantId', title: 'Variant' },
        { key: 'variantRelation', title: 'Relation' }
    ];
    selectedConditions = [];
    actions = ['disable', 'enable'];
    relations = ['equals', 'contains', 'notContains', 'startsWith', 'endsWith'];
    segment = ['long_haul', 'regional_haul', 'mining_and_quary', 'building_and_construction'];
    locales = [];
    connectors = ['OR', 'AND'];
    data = [];
    rows = [];
    subcategories = [];
    selected = new Set();
    originalRowForEdit: any = null;

    oldCondition;
    products;
    selectedProduct;


    @ViewChild(ConfirmPopupComponent)
    confirmPopup: ConfirmPopupComponent;

    constructor(
        private route: ActivatedRoute,
        private policiesService: PoliciesService,
        private configurationService: ConfigurationService,
        private subcategoriesService: SubcategoriesService,
        private translate: TranslateService,
        private toasterService: ToasterService,
        private modalService: BsModalService,
        private translationsService: TranslationsService,
        private logger: Logger
    ) {
    }

    init() {
      this.policiesService.getList().subscribe((data: any) => {
        const rules = data.products;

        this.configurationService.getList('products', LOCALE_CONFIG.DEFAULT_LOCALE).subscribe(({ result: { products } }) => {
          let subcategories = [];
          this.subcategoriesService.getList(LOCALE_CONFIG.DEFAULT_LOCALE).subscribe(data => {
            subcategories = data.subcategories.map(s => s.name)
            this.subcategories = Array.from(new Set(subcategories))
          })
            const productsWithRuls = products.map(p => {
                const currentWithRuls = rules.find(r => r.productId === p.name);
                return {
                    ...p,
                    rules: currentWithRuls ? currentWithRuls.rules : []
                }
            })
            this.products = productsWithRuls;
            this.products.map(p => {
              p.description = p.name.toUpperCase();
              p.rules.map(r => {
                if (r.locale !== undefined) {
                  r.locale = r.locale.map(pp => pp.toLowerCase());
                }
                return r;
              });
            });
            this.selectedProduct = this.products[0].id;
            this.search();
        });
      });

      this.translationsService.getLocalizations().subscribe((data) => {
        this.locales = data.reduce((acc, cur, i) => {
            cur.locales.forEach((locale) => {
              acc = [...acc, {
                localeName: locale,
                languageCode: cur.language,
                languageTitle: cur.title,
              }];
            });
            return acc;
        }, []);
        this.locales.unshift({
            localeName: LOCALE_CONFIG.DEFAULT_LOCALE,
            languageCode: "Global",
            languageTitle: "Global",
          });
        this.locales.sort((a, b) => a.localeName.localeCompare(b.localeName));
      });

    }

    ngOnInit() {
      this.init();
    }

    getList() {
        this.data = [];
        this.policiesService.getList().subscribe((data: any) => {
            this.data = data;
            this.search();
        });
    }

    eventEmitted($event) {
        switch ($event.event) {
            case 'onSelectAll':
                this.data.forEach((val, key) => {
                    if (this.selected.has(key)) {
                        this.selected.delete(key);
                    } else {
                        this.selected.add(key);
                    }
                });
                break;
            case 'onDoubleClick':
                this.editRow($event.value.row);
                break;
        }
    }

    showEditForm(template: TemplateRef<any>) {
        this.editModalRef = this.modalService.show(template);
    }

    editRow(row) {
        const editedRow = {
            ...row,
            conditions: row.conditions.map(cond => {
                return {
                  subcategoryId: cond.subcategoryId,
                  subcategoryRelation: cond.subcategoryRelation,
                  variantId: cond.variantId,
                  variantRelation: cond.variantRelation
                }
            }),
        }
        this.selectedRow = editedRow;
        this.selectedRow = Object.assign({}, editedRow);
        this.originalRowForEdit = Object.assign({}, row);
        // this.selectedRow = this.originalRowForEdit = Object.assign({}, editedRow);
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }


    addCondition() {
      let condition = {
        subcategoryId: '',
        subcategoryRelation: '',
        variantId: '',
        variantRelation: ''
      };
      this.selectedRow.conditions.push(condition);

      this.selectedRowCondition = condition;
      this.oldCondition = {};
      this.editModalConditionRef = this.modalService.show(this.editConditionTemplate);
    }

    async removeCondition(condition) {
        this.selectedRowCondition = condition;
        if (this.selectedRowCondition) {
          this.confirmPopup.message = await this.translate.get('webpanel.product_settings.remove_product_condition_confirmation', {
              product_setting: this.selectedRow ? this.selectedRow.name : ''
          }).toPromise();
          this.confirmPopup.dataType = 'condition';
          this.confirmPopup.show();
        }
    }

    editCondition(condition) {
          this.selectedRowCondition = condition;
          this.oldCondition = JSON.parse(JSON.stringify(this.selectedRow.conditions));
          this.editModalConditionRef = this.modalService.show(this.editConditionTemplate);
    }

    cancelCondition() {
      if (Object.keys(this.oldCondition).length == 0) {
        this.selectedRow.conditions = this.selectedRow.conditions.filter(c => {
          if (c.subcategoryId !== '' && c.subcategoryRelation !== '' && c.variantId !== '' && c.variantRelation !== '') {
            return c;
          }
        });
      } else {
        this.selectedRow.conditions = JSON.parse(JSON.stringify(this.oldCondition));
      }
      this.editModalConditionRef.hide();
    }

    toggleRow({ target: { checked } }, row) {
        const index = this.data.indexOf(row);
        if (checked) {
            this.selected.add(index);
        } else {
            this.selected.delete(index);
        }
    }

    isRowSelected(row) {
        return this.selected.has(this.data.indexOf(row));
    }

    saveData(data) {
      this.policiesService.update(data).subscribe(async (result) => {
          this.init();
          const successMessage = await this.translate.get('webpanel.product_settings.save.success_message').toPromise();
          this.toasterService.pop('success', '', successMessage);
      });

    }

    async saveProductPolicies() {
        const filteredProduct = this.products.find(r => r.id === this.selectedProduct);
        let cond = [];
        let error = false;
        if (this.selectedRow && this.selectedRow.conditions) {
            this.selectedRow.conditions.forEach(c => {
              if(c.subcategoryId === '' || c.subcategoryRelation === '' || c.variantId === '' || c.variantRelation === '') {
                error = true;
              }
              cond.push({
                subcategory: {
                  id: c.subcategoryId,
                  relation: c.subcategoryRelation
                },
                variant: {
                    id: c.variantId,
                    relation: c.variantRelation
                }
              });
            }
          );
        }
        if(cond.length === 0 || error) {
          const errorMessage = await this.translate.get('webpanel.product_settings_condition.save.error_message').toPromise();
          this.toasterService.pop('error', '', errorMessage);
          return false;
        }
        this.selectedRow.conditions = cond;
        const payload = {
            productId: filteredProduct.name,
            name: this.selectedRow.name,
            action: this.selectedRow.action,
            segment: this.selectedRow.segment,
            locale: this.selectedRow.locale,
            variant: this.selectedRow.variant,
            connector: this.selectedRow.connector,
            subGroups: this.selectedRow.subGroups,
            conditions: this.selectedRow.conditions,
            target: this.selectedRow.target,
            subcategory: this.selectedRow.subcategory
        };
        this.saveData(payload);
        this.editModalRef.hide();
    }

    async saveProductConditionPolicies() {
      const filteredProduct = this.products.find(r => r.id === this.selectedProduct);
      let cond = [];
      let error = false;
      this.selectedRow.conditions.forEach(c => {
          if(c.subcategoryId === '' || c.subcategoryRelation === '' || c.variantId === '' || c.variantRelation === '') {
            error = true;
          }
          cond.push({
            subcategory: {
              id: c.subcategoryId,
              relation: c.subcategoryRelation
            },
            variant: {
                id: c.variantId,
                relation: c.variantRelation
            }
          });
        }
      );
      if(cond.length === 0 || error) {
          const errorMessage = await this.translate.get('webpanel.product_settings_condition.save.error_message').toPromise();
          this.toasterService.pop('error', '', errorMessage);
          return false;
      }

      this.editModalConditionRef.hide();
      this.selectedRow.conditions = cond;
      const payload = {
          productId: filteredProduct.name,
          name: this.selectedRow.name,
          action: this.selectedRow.action,
          segment: this.selectedRow.segment,
          locale: this.selectedRow.locale,
          variant: this.selectedRow.variant,
          connector: this.selectedRow.connector,
          subGroups: this.selectedRow.subGroups,
          conditions: this.selectedRow.conditions,
          target: this.selectedRow.target,
          subcategory: this.selectedRow.subcategory
      };
      this.saveData(payload);
      this.editModalRef.hide();
    }

    search() {
        let rows = [];
        const filteredProduct = this.products.find(r => r.id === this.selectedProduct);
        filteredProduct.rules.forEach(r => {
            const conditions = [];
            r.conditions.forEach(cond => conditions.push({
                subcategoryId: cond.subcategory.id,
                subcategoryRelation: cond.subcategory.relation,
                variantId: cond.variant.id,
                variantRelation: cond.variant.relation
            }))
            rows.push({
                id: r.name,
                name: r.name,
                action: r.action,
                segment: r.segment,
                locale: r.locale,
                variant: r.target.variant,
                connector: r.connector,
                subGroups: r.subGroups,
                conditions: conditions,
                target: r.target,
                subcategory: r.target.subcategory
            })
        })
        this.rows = rows.filter(r => (r.name || r.name === '') && r.action && (this.searchTerm.length === 0 ||
            r.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
            r.action.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
            r.subcategory.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
            r.variant.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
            (r.locale !== undefined && r.locale.includes(this.searchTerm.toLowerCase())) ||
            (r.segment !== undefined && r.segment.includes(this.searchTerm.toLowerCase()))
        ));
        return this.rows;
    }

    addNew() {
        this.selectedRow = {
            id: '',
            name: '',
            action: '',
            segment: [],
            locale: [],
            variant: '',
            connector: '',
            subGroups: [],
            conditions: [],
            target: '',
            subcategory: '',
            new: true
        };
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    searchKeyPress(event) {
        if (event.which === 13) {
            this.search();
        }
    }

    async removeItem(item) {
        this.selectedRow = item;
        if (this.selectedRow) {
            this.confirmPopup.message = await this.translate.get('webpanel.product_settings.remove_product_setting_confirmation', {
                product_setting: this.selectedRow ? this.selectedRow.name : ''
            }).toPromise();
            this.confirmPopup.dataType = 'item';
            this.confirmPopup.show();
        }
    }

    confirm(res) {
        this.confirmPopup.hide();
        if(this.confirmPopup.dataType == 'condition') {
            this.confirmCondition(res);
        } else if(this.confirmPopup.dataType == 'item') {
            this.confirmItem(res);
        }
    }

    confirmItem(res) {
      if (res) {
        if (this.selectedRow) {
            const filteredProduct = this.products.find(r => r.id === this.selectedProduct);
            this.policiesService.delete(filteredProduct.name, this.selectedRow.name ? this.selectedRow.name : '---').subscribe(async (resp) => {
                this.selectedRow = null;
                const successMessage = await this.translate.get('webpanel.product_settings.delete.success_message').toPromise();
                this.toasterService.pop('success', '', successMessage);
                this.getList();
            });
        }
      } else {
          this.selectedRow = this.originalRowForEdit;
          this.originalRowForEdit = null;
      }
    }

    confirmCondition(res) {
      if (res) {
          if (this.selectedRowCondition) {
              const filteredProduct = this.products.find(r => r.id === this.selectedProduct);
              let cond = [];
              this.selectedRow.conditions.forEach(c => {
                    if(c.subcategoryId == this.selectedRowCondition.subcategoryId &&
                          c.subcategoryRelation == this.selectedRowCondition.subcategoryRelation &&
                          c.variantId == this.selectedRowCondition.variantId &&
                          c.variantRelation == this.selectedRowCondition.variantRelation) {
                    } else {
                        cond.push({
                            subcategory: {
                                id: c.subcategoryId,
                                relation: c.subcategoryRelation
                            },
                            variant: {
                                id: c.variantId,
                                relation: c.variantRelation
                            }
                        });
                    }
              });
              this.selectedRow.conditions = cond;

              if(cond.length > 0) {
                const payload = {
                    productId: filteredProduct.name,
                    name: this.selectedRow.name,
                    action: this.selectedRow.action,
                    segment: this.selectedRow.segment,
                    locale: this.selectedRow.locale,
                    variant: this.selectedRow.variant,
                    connector: this.selectedRow.connector,
                    subGroups: this.selectedRow.subGroups,
                    conditions: this.selectedRow.conditions,
                    target: this.selectedRow.target,
                    subcategory: this.selectedRow.subcategory
                };
                this.saveData(payload);
                this.editModalRef.hide();
              }
          } else {
              this.editModalRef.hide();
              this.selectedRow = this.originalRowForEdit;
              this.originalRowForEdit = null;
          }
      }
    }

    decline() {
        this.selectedRow = this.originalRowForEdit;
        this.originalRowForEdit = null;
    }

    fileUpload({target}) {
      if (this.isUploading) {
          return;
      }
      this.isUploading = true;
      const fileField = target;
      const file = fileField.files[0];
      const reader = new FileReader();
      reader.onload = () => {
          const result = JSON.parse(reader.result);
          this.policiesService.uploadImport(result).subscribe(async (response) => {
            this.getList();
            this.isUploading = false;
            fileField.value = '';
          });
      };
      reader.readAsText(file);
  }

  saveFile() {
    this.isExporting = true;
    this.policiesService.getExport().subscribe(response => {
        this.saveToFileSystem(response);
    });
  }

  private async saveToFileSystem(response) {
    const fileContent = JSON.stringify(response, null, 2);
    const blob = new Blob([fileContent], {type: 'text/plain'});
    saveAs(blob, 'configurator-' + moment().format('YYYYMMDD-HHmm') + '.json');
    this.isExporting = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/settings-policies/settings-policies.component.ts